import { SCTypeEnum, SCTypeStrings } from "../../modules/CalculationsPage/enums";
import i18nStore from "../../i18n/store";
import React from "react";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import theme from "../../assets/theme";
import Tooltip from '@mui/material/Tooltip';


export interface KZTypeSelectorProps {
    kzType: number;
    setKzType: (kzType: number) => void;
    id?: string;
}


const KZTypeSelector = (props: KZTypeSelectorProps) => {
    const translations = i18nStore.getTranslations;

    const handleChangeKzType = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if (newAlignment) {
            props.setKzType(+newAlignment as SCTypeStrings);
        } else {
            props.setKzType(1);
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body2" sx={{ color: theme.palette.grey.A700}}>{translations.shortCircuitType}</Typography>
            <ToggleButtonGroup
                color="primary"
                value={props.kzType}
                exclusive
                onChange={handleChangeKzType}
                size="small"
                sx={{
                    "& .Mui-selected": {
                        color: "white !important",
                        background: `${theme.palette.primary.main} !important`,
                    },
                }}
            >
                <Tooltip title={translations._typeDamage.K1Long}>
                    <ToggleButton
                        sx={{
                            minWidth: "40px",
                        }}
                        value={SCTypeEnum.K1}
                    >
                        1
                    </ToggleButton>
                </Tooltip>
                <Tooltip title={translations._typeDamage.K11Long}>
                    <ToggleButton
                        sx={{
                            minWidth: "40px",
                        }}
                        value={SCTypeEnum.K11}
                    >
                        11
                    </ToggleButton>
                </Tooltip>
                <Tooltip title={translations._typeDamage.K2Long}>
                    <ToggleButton
                        sx={{
                            minWidth: "40px",
                        }}
                        value={SCTypeEnum.K2}
                    >
                        2
                    </ToggleButton>
                </Tooltip>
                <Tooltip title={translations._typeDamage.K3Long}>
                    <ToggleButton
                        sx={{
                            minWidth: "40px",
                        }}
                        value={SCTypeEnum.K3}
                    >
                        3
                    </ToggleButton>
                </Tooltip>
            </ToggleButtonGroup>
        </Box>

    );
};

export default KZTypeSelector;
